import { get, post, put, putCustomToken, getCustomToken, postCustomToken } from "../apiUtil";
import { isNullOrWhiteSpace } from "services/utility/utils"

export const getAllMontlyNew = (start, end, offset, userId) => {
    let url = 'appointment?StartRange=' + start + '&EndRange=' + end + '&TimeZoneOffset=' + offset;
    if (!isNullOrWhiteSpace(userId)) {
        if (userId > 0) {
            url += "&userId=" + userId;
        }
    }
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, url)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });

};

export const getAllMontlyCalendersNew = function (start, end, offset, groupId) {
    let url = 'appointment/group?StartRange=' + start + '&EndRange=' + end + '&TimeZoneOffset=' + offset;
    if (!isNullOrWhiteSpace(groupId)) {
        if (groupId > 0) {
            url += "&groupId=" + groupId;
        }
    }

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, url)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};

export const getAppointmentEvent = function (id) {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'appointment/' + id)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};
export const getAppointmentEventWithToken = function (id, token, skipLoader = false) {

    return new Promise((resolve) => {
        getCustomToken(process.env.REACT_APP_API_URL, 'appointment/' + id, token, skipLoader)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};

export const getCalendarGroups = function (id) {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'calendargroups')
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};


export const postAppointmentEvent = function (obj) {

    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, 'appointment', obj)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};

export const postAppointmentEventWithToken = function (obj, token) {

    return new Promise((resolve) => {
        postCustomToken(process.env.REACT_APP_API_URL, `appointment`, token, obj)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};

export const putAppointmentEvent = function (obj) {

    return new Promise((resolve) => {
        put(process.env.REACT_APP_API_URL, 'appointmentevents', obj)
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
};


export const putAppointmentEventWithToken = function (obj, token) {
    if (token) {
        return new Promise((resolve) => {
            putCustomToken(process.env.REACT_APP_API_URL, 'appointmentevents', token, obj)
                .then((response) => {

                    return resolve({ success: true, receiveObj: response.data })
                })
                .catch((error) => {
                    return resolve({ success: false, receiveObj: error })
                });

        });
    }
};


export const getAppointmentEventsForToday = function (token, code, skipLoader = false) {
    return new Promise((resolve) => {
        getCustomToken(process.env.REACT_APP_API_URL, 'appointment/event', token, skipLoader).then((response) => {
            return resolve({ success: true, receiveObj: response.data, code: code });
        })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error });
            });
    });
};

export const getAppointmentTeamEventsForToday = function (token, code, skipLoader = false) {
    return new Promise((resolve) => {
        getCustomToken(process.env.REACT_APP_API_URL, 'appointment/team_event', token, skipLoader)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data, code: code })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });
    });
};

export const putDispositionStatus = function (payload, token = null) {

    if (token) {
        return new Promise((resolve) => {
            putCustomToken(process.env.REACT_APP_API_URL, 'appointment/disposition', token, payload)
                .then((response) => {
                    return resolve({ success: true, receiveObj: response.data })
                })
                .catch((error) => {
                    return resolve({ success: false, receiveObj: error })
                });
        });
    }

    return new Promise((resolve) => {
        put(process.env.REACT_APP_API_URL, 'appointment/disposition', payload)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });
    });
};


export const getProcessingJobsWithToken = (token, skipLoader = false) => {
    return new Promise((resolve) => {
        getCustomToken(
            process.env.REACT_APP_CONFIGURATION_URL,
            "campaign/job/processing",
            token,
            skipLoader
        )
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data });
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error });
            });
    });
};

export const getAllMontlyNewWithToken = (start, end, offset, userId, token, code, skipLoader = false) => {
    let url = 'appointment?StartRange=' + start + '&EndRange=' + end + '&TimeZoneOffset=' + offset;
    if (!isNullOrWhiteSpace(userId)) {
        if (userId > 0) {
            url += "&userId=" + userId;
        }
    }
    return new Promise((resolve) => {
        getCustomToken(
            process.env.REACT_APP_API_URL,
            url,
            token,
            skipLoader
        )
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data, token: token, userId: userId, code: code });
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error });
            });
    });
};

export const getAllMontlyCalendersNewWithToken = function (start, end, offset, groupId, token, userId, code, skipLoader = false) {
    let url = 'appointment/group?StartRange=' + start + '&EndRange=' + end + '&TimeZoneOffset=' + offset;
    if (!isNullOrWhiteSpace(groupId)) {
        if (groupId > 0) {
            url += "&groupId=" + groupId;
        }
    }

    return new Promise((resolve) => {
        getCustomToken(
            process.env.REACT_APP_API_URL,
            url,
            token,
            skipLoader
        )
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data, token: token, userId: userId, code: code });
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error });
            });
    });
};